<template>
  <div class="user_name-container">
    <div class="user_name-icon" :style="{ backgroundColor: color }">
      {{ initialsName(user.first_name, user.last_name) }}
    </div>
    <div class="user_name-info">
      <div class="font-weight-bold" style="color: #333">
        <span v-if="user.first_name">{{ user | concatName2 | titleize }}</span>
      </div>
      <div class="text-secondary fs-14">{{ user.email || '' }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NameInitialsIcon',
  props: {
    user: {
      type: Object,
      required: true,
      default: () => ({})
    },
    color: {
      type: String,
      default: '#5A6489'
    }
  },
  methods: {
    initialsName (firstName, lastName) {
      if (!firstName && !lastName) { return 'N/A' }
      firstName = firstName?.charAt(0) || ''
      lastName = lastName?.charAt(0) || ''
      return firstName + lastName
    },
  }
}
</script>

<style scoped>
.user_name-container {
  display: flex;
  align-items: center;
}
.user_name-icon {
  width: 37px;
  height: 37px;
  background-color: #5A6489;
  color: white;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 15px;
  margin-right: 10px;
}
.user_name-info {
  display: flex;
  justify-content: center;
  flex-direction: column;
  line-height: 19px;
}
</style>